import React from "react";
import logo from '../404.png';
import { Col, Container, Row } from "react-bootstrap";

/**
 * NoMatchPage - 404 Page
 * 
 * Will be shown when user ends up on route that does not exist.
 * 
 * @url "*"
 * @component None
 * @returns None
 */
const NoMatchPage = () => {

    // View
    return (
        <div className="logout-box">
            <Container fluid style={{height: "100%", width: "100%"}}>
                <Row className="logout-box align-items-center text-center">
                    <Col xs="12">
                        <img src={logo} alt="logo" className="img-fluid animate__animated animate__shakeX" />
                        <h1 className="text-light mt-5">Die aufgerufene Adresse konnte nicht gefunden werden.</h1>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default NoMatchPage;